import { render, staticRenderFns } from "./DashboardCourseById.vue?vue&type=template&id=fd1b3018&"
import script from "./DashboardCourseById.vue?vue&type=script&lang=js&"
export * from "./DashboardCourseById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports